import styled from 'styled-components';
import { ALABASTER, STEEL_BLUE, WHITE } from 'constants/colors';
import { FieldWrap } from 'components/Field/styles';
import Panel from 'components/Panel';
import { genericBorder } from 'assets/styles/utils';

export const BaseContainerWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${WHITE};
  @media (min-width: 550px) {
    background-color: ${ALABASTER};
  }
  width: 100%;
  height: 100%;
  > ${Panel} {
    align-items: center;
    justify-content: center;
    border: none;
    @media (min-width: 550px) {
      border: ${genericBorder()};
      max-width: 90%;
    }
    @media (min-width: 768px) {
      max-width: 30rem;
    }
  }
`;
export const LogoWrap = styled.div`
  min-width: 6rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
  > svg {
    width: 100%;
    height: 100%;
  }
`;
export const FormWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 2.5rem;
  width: 100%;
  box-sizing: border-box;
  > form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  ${FieldWrap} {
    width: 100%;
  }
`;

export const FormLink = styled.a`
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: bold;
  color: ${STEEL_BLUE};
  > * {
    margin-left: 0.5rem;
    &:first-child {
      margin-left: 0;
    }
  }
  &:hover {
    text-decoration: underline;
  }
`;
